export const haveActivityItemPropsChanged = (prev, next) => {
  return (
    prev.type === next.type &&
    prev.causer_id === next.causer_id &&
    prev.created_at === next.created_at
  );
};
